module.exports = __webpack_public_path__ + "static/media/proj1_img5.71ad89a1.jpg";